export default __webpack_public_path__ + "static/media/guide02.2454fcd1.png";